module.exports = __webpack_public_path__ + "img/imagenSeisFinanzas.0a47cb3a.jpg";